import { ComponentStatus } from 'bom/enums';
import { Color } from 'theme/enums';
import { IColorMap } from 'theme/types';

export const COMPONENT_EMPTY_NAME = 'No Component Assigned';

export const statusColorMap: IColorMap = {
  [ComponentStatus.ACCEPTED]: Color.SUCCESS,
  [ComponentStatus.REJECTED]: Color.DANGER,
  [ComponentStatus.PENDING]: Color.WARNING,
  [ComponentStatus.DELETED]: Color.DANGER,
};
